<template>  
  <div class="main">
    <div class="alarmText">
      用水量趋势图
    </div>
    <div class="buttonGroup">
      <el-button-group>
        <el-button size="mini" :type="buttonType.year" @click="chooseType('YEAR')">年</el-button>
        <el-button size="mini" :type="buttonType.month"  @click="chooseType('MONTH')">月</el-button>
        <el-button size="mini" :type="buttonType.day"  @click="chooseType('DAY')">日</el-button>
      </el-button-group>
    </div>

  </div>

</template>

<script>
  import * as date from "../../../../../static/js/date.js"
  export default {
    name: 'UseTrendTitle',
    data() {
      return {
        'useTrendType':'year',
        'buttonType': {
          'year':'info',
          'month':'',
          'day':''
        }
      }
    },
    mounted() {
      
    },
    created() {
    },
    methods: {
      // 选择查看类型TODO:改变数据
      chooseType(type) {
        this.$store.commit('saveUseTrendType',type);
        switch (type) {
          case 'YEAR':
            this.buttonType = {
              'year':'info',
              'month':'',
              'day':''
            }
            break;
          case 'MONTH':
            this.buttonType = {
              'year':'',
              'month':'info',
              'day':''
            }
            break;
          case 'DAY':
            this.buttonType = {
              'year':'',
              'month':'',
              'day':'info'
            }
            break;
        
          default:
            break;
        }
      }
    },
    props: []
  }
</script>

<style lang="scss" scoped>
.main {
  color: #999;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  .el-button--info{
    border-color: #5c75f3 !important;
    color: #5c75f3;
    background: none;
  }
}
.alarmText {
  font-size: 1em;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CWaterManage/BuildingInfo/UseTrendTitle.vue